import { deleteContactRequest, getAllContactRequest } from "../api";
import { CONTACT_REQUEST_DELETE, CONTACT_REQUEST_GET_ALL } from "../common/constants";
import ToastPopup from "../common/ToastPopup";

const fetchAllContactRequest = async () => {
	const response = await getAllContactRequest();
	if (response?.success) {
		return response?.results ?? {};
	} else {
		ToastPopup(
			"error",
			response?.message + (response?.errors ? ". " + Object.values(response?.errors) : "")
		);
		return null;
	}
};

const deleteSingleContactRequest = async (id) => {
	const response = await deleteContactRequest(id);
	if (response?.success) {
		ToastPopup("success", response?.message);
		return response?.results ?? {};
	} else {
		ToastPopup(
			"error",
			response?.message + (response?.errors ? ". " + Object.values(response?.errors) : "")
		);
		return null;
	}
};

const handleRequest = (requestFn, args, state, action) => {
	if (action.loading) {
		requestFn
			.apply(null, args)
			.then((res) => action.dispatch({ ...action, loading: false, data: res }));
		return state;
	} else {
		action.loadingCb();
		if (action.data) {
			action.successCb();
			return action.data;
		} else {
			action.failedCb();
			return state;
		}
	}
};

export const ContactRequestReducer = (state, action) => {
	switch (action.type) {
		case CONTACT_REQUEST_GET_ALL:
			return handleRequest(fetchAllContactRequest, [], state, action);
		case CONTACT_REQUEST_DELETE:
			return handleRequest(deleteSingleContactRequest, [action.id], state, action);

		default:
			break;
	}
};
